// KL guide: aircond HP room size guide. Rules of thumb only.
const content = {
    slug: 'aircond-hp-room-size-guide',
    title: 'Aircond HP Room Size Guide | 1.0hp vs 1.5hp vs 2.0hp',
    description: 'Which aircond horsepower for your room in Malaysia: a simple sq ft table for 1.0hp to 2.5hp, what changes the answer, and signs your unit is the wrong size.',
    eyebrow: 'KL · Aircond guide',
    h1: 'Aircond HP Room Size Guide: 1.0hp, 1.5hp or 2.0hp?',
    lead: 'In Malaysia, aircond is sold by horsepower (HP). Buy too small and the room never gets cold on a hot afternoon; too big and you pay more upfront and the room feels damp. Use this table as a starting point.',
    datePublished: '2026-10-03',
    image: 'blog/living/daikin-inverter.png',
    imageAlt: 'Wall-mounted inverter aircond unit',
    summary: {
        title: 'Quick answer',
        items: [
            'Standard bedroom (100-150 sq ft): 1.0hp.',
            'Master bedroom (150-250 sq ft): 1.5hp.',
            'Living room (250-350 sq ft): 2.0hp.',
            'Size up for west-facing rooms, top floors and kitchens nearby.',
        ],
    },
    sections: [
        {
            title: 'Room size to HP',
            table: {
                columns: [
                    { key: 'sqft', label: 'Room size' },
                    { key: 'hp', label: 'Suggested HP' },
                    { key: 'btu', label: 'Approx. BTU/h' },
                ],
                rows: [
                    { sqft: 'Up to 150 sq ft (14 m²)', hp: '1.0hp', btu: '9,000' },
                    { sqft: '150 - 250 sq ft (14-23 m²)', hp: '1.5hp', btu: '12,000' },
                    { sqft: '250 - 350 sq ft (23-33 m²)', hp: '2.0hp', btu: '18,000' },
                    { sqft: '350 - 450 sq ft (33-42 m²)', hp: '2.5hp', btu: '22,000-24,000' },
                    { sqft: '450 sq ft + (42 m² +)', hp: '3.0hp or ceiling cassette', btu: '24,000 +' },
                ],
            },
            note: 'Rules of thumb for Malaysian homes. For large open-plan areas or offices, ask for a proper heat-load assessment.',
        },
        {
            title: 'What changes the answer',
            cards: [
                { title: 'Afternoon sun', body: 'West-facing rooms and rooms with big windows heat up badly after 2pm - go one size up.' },
                { title: 'Top floor or roof', body: 'Top-floor condo units and the upstairs of terrace houses absorb roof heat.' },
                { title: 'Open kitchens', body: 'Cooking adds heat to living rooms that open into the kitchen.' },
                { title: 'High ceilings', body: 'Bungalow and shophouse ceilings mean more air to cool.' },
            ],
        },
        {
            title: 'Wrong size? Rule out dirt first',
            paragraphs: [
                'A dirty coil or low gas can make a correctly sized aircond feel too small. Before you replace a unit that "can\'t cope", get it serviced - many units recover most of their cooling after a chemical wash.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Is 1.0hp enough for a 12x12 room?',
            answer: 'A 144 sq ft room is at the top of the 1.0hp range. If it faces west or is on the top floor, choose 1.5hp.',
        },
        {
            question: 'Does a bigger HP use more electricity?',
            answer: 'A bigger unit draws more power, but an undersized one runs non-stop. A correctly sized inverter unit is usually the cheapest to run.',
        },
    ],
    cta: {
        title: 'Room not cooling well?',
        body: 'Check the unit before replacing it.',
        href: '/my/aircond-service-kuala-lumpur/aircond-not-cold',
        label: 'Aircond not cold: causes and fixes',
    },
}

export default content
